import clsx from 'clsx';
import React from 'react';

import styles from './SquareLoader.module.scss';

interface ISquareLoaderProps {
  /** `true`일 경우 전체 화면 대신 부모 요소만 덮음. */
  isNested?: boolean;
  'data-test'?: string;
}

/**
 * 사각형 풀스크린 로드 인디케이터.
 */
const SquareLoader: React.FC<ISquareLoaderProps> = ({ isNested, 'data-test': testID = 'loader' }) => (
  <div className={clsx(styles.container, isNested && styles.nested)} data-test={testID}>
    <div className={styles.square} />
    <div className={clsx(styles.image, styles.image1)} />
    <div className={clsx(styles.image, styles.image2)} />
    <div className={clsx(styles.image, styles.image3)} />
  </div>
);

export default SquareLoader;
